import React, { useState, useEffect } from 'react';
import PageLoading from "../PageLoading.js";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import { BotonBuscarCliente } from '../Plantillas/Botones.js';

const ModalBuscarVendedor = ({ onSelectVendedor }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchVendedores = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/vendedores');
            const result = await response.json();

            if (Array.isArray(result)) {
                // Solo vendedores activos
                setData(result.filter(v => v.Activo === 1 || v.Activo === true));
            }
        } catch (error) {
            console.error("Error fetching vendedores:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVendedores();
    }, []);

    if (loading && data.length === 0) {
        return <PageLoading />;
    }

    return (
        <div className="container mt-3 mb-3">
            <ReactTable
                data={data}
                filterable
                defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
                columns={[
                    {
                        Header: "Acción",
                        filterable: false,
                        width: 120,
                        Cell: ({ original }) => (
                            <div style={{ textAlign: "center" }}>
                                <BotonBuscarCliente
                                    title="Escoger Vendedor"
                                    onClick={() => onSelectVendedor(original)}
                                />
                            </div>
                        )
                    },
                    {
                        Header: "DNI / RUC",
                        accessor: "NroDocumento",
                        width: 150,
                        className: "text-center",
                        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["NroDocumento"] }),
                        filterAll: true
                    },
                    {
                        Header: "Vendedor",
                        accessor: "RazonSocial",
                        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["RazonSocial"] }),
                        filterAll: true
                    }
                ]}
                defaultPageSize={5}
                showPagination={false}
                //pageSize={10}
                className="-striped -highlight"
                previousText='Anterior'
                nextText='Siguiente'
                loadingText='Cargando...'
                noDataText='No se encontraron registros'
                pageText='Página'
                ofText='de'
                rowsText='filas'
                style={{ fontSize: "15px" }}
            />
        </div>
    );
};

export default ModalBuscarVendedor;
